<div #wrapper class="wrapper">
  <ng-content></ng-content>
</div>
